<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center py-1 px-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="fa fa-balance-scale text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'" style="font-size: 1.15rem;">Conciliação Bancária</h4>
            <small class="text-muted small">Gerenciamento de conciliações bancárias</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 py-1 px-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <b-button-group class="mr-2 d-lg-none">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <div style="min-width: 250px">
                        <b-form-input 
                            v-model="textoPesquisa" 
                            placeholder="Buscar por arquivo..."
                            class="shadow-xs" 
                            style="font-size: 0.9rem;"
                            @keydown.enter.native="pesquisar()">
                        </b-form-input>
                    </div>
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> <span class="d-none d-sm-inline">FILTRAR</span>
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm btn-adicionar-responsive" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-1"></i>
              <span class="d-none d-sm-inline">Nova Conciliação</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="3">
                      <label class="small font-weight-bold text-muted">Conta Bancária</label>
                      <b-form-select v-model="filtroContaId" class="shadow-xs">
                        <b-form-select-option :value="null">Todas</b-form-select-option>
                        <b-form-select-option v-for="conta in contasBancarias" :key="conta.CODIGO" :value="conta.CODIGO">
                          {{ conta.CODIGONOME }}
                        </b-form-select-option>
                      </b-form-select>
                    </b-col>
                    <b-col md="3">
                      <label class="small font-weight-bold text-muted">Data Inicial</label>
                      <b-form-input type="date" v-model="filtroDataInicial" class="shadow-xs"></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <label class="small font-weight-bold text-muted">Data Final</label>
                      <b-form-input type="date" v-model="filtroDataFinal" class="shadow-xs"></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <label class="small font-weight-bold text-muted">Status</label>
                      <b-form-select v-model="filtroStatus" class="shadow-xs">
                        <b-form-select-option v-for="opt in statusOptions" :key="opt.value || 'all'" :value="opt.value">
                          {{ opt.text }}
                        </b-form-select-option>
                      </b-form-select>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table 
                    ref="tbl"
                    class="mb-0 table-finance"
                    :head-variant="isDark ? 'dark' : 'light'"
                    :dark="isDark"
                    show-empty
                    empty-text="Nenhuma conciliação encontrada"
                    responsive 
                    :sticky-header="stickyHeight"
                    hover 
                    small
                    :busy.sync="isBusy" 
                    :items="itensFiltrados" 
                    :fields="colunas"
                    :current-page="currentPage"
                    @row-clicked="clicarLinha"
                    :per-page="perPage"
                    @row-dblclicked="edit"
                    :tbody-tr-class="rowClassSelecionado"    
                    >
              
              <template #head(ID)>
                <SetFilter label="ID" v-model="filtros.ID" :options="opcoes.ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(CONTA_NOME)>
                <SetFilter label="Conta" v-model="filtros.CONTA_NOME" :options="opcoes.CONTA_NOME" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(BANCO_NOME)>
                <SetFilter label="Banco" v-model="filtros.BANCO_NOME" :options="opcoes.BANCO_NOME" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(NOME_ARQUIVO)>
                <SetFilter label="Arquivo" v-model="filtros.NOME_ARQUIVO" :options="opcoes.NOME_ARQUIVO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(STATUS)>
                <SetFilter label="Status" v-model="filtros.STATUS" :options="opcoes.STATUS" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              
              <template #empty>
                <div class="h-100 d-flex align-items-center justify-content-center">
                  Nenhum registro encontrado
                </div>
              </template>
              
              <template #cell(actions)="item">
                <div class="d-flex justify-content-center gap-1">
                  <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="abrirModalCancelar(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Cancelar" v-b-tooltip.hover>
                    <i class="fa fa-ban"></i>
                  </b-button>
                </div>
              </template>

              <template #cell(STATUS)="row">
                <b-badge :variant="getVariantStatus(row.item.STATUS)" pill>
                  {{ getLabelStatus(row.item.STATUS) }}
                </b-badge>
              </template>

              <template #cell(DATA_INICIAL)="row">
                {{ formatarDataBR(row.item.DATA_INICIAL) }}
              </template>

              <template #cell(DATA_FINAL)="row">
                {{ formatarDataBR(row.item.DATA_FINAL) }}
              </template>

              <template #cell(TRANSACOES)="row">
                <span class="text-right d-block">{{ row.item.TRANSACOES || 0 }}</span>
              </template>

              <template #cell(TOTAL_CONCILIADO)="row">
                <span class="text-right d-block font-weight-bold text-success">
                  {{ formatarMoeda(row.item.TOTAL_CONCILIADO || 0) }}
                </span>
              </template>

              <template #cell(TOTAL_PENDENTE)="row">
                <span class="text-right d-block font-weight-bold text-warning">
                  {{ formatarMoeda(row.item.TOTAL_PENDENTE || 0) }}
                </span>
              </template>

            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Modal de Confirmação de Cancelamento -->
    <b-modal
        ref="modalCancelar"
        title="Cancelar Conciliação"
        ok-variant="danger"
        ok-title="Sim, Cancelar"
        cancel-title="Não"
        @ok="cancelar"
        centered>
      <div v-if="itemCancelar">
        <p class="mb-2">Deseja realmente cancelar esta conciliação bancária?</p>
        <p class="mb-3 text-muted">
          Se a conciliação não possuir vínculos nem itens conciliados, os itens importados serão removidos e o cabeçalho será cancelado.
          Se houver vínculos ou itens já conciliados, o cancelamento será bloqueado.
        </p>
        <div class="card bg-light">
          <div class="card-body">
            <p class="mb-1"><strong>ID:</strong> {{ itemCancelar.ID }}</p>
            <p class="mb-1"><strong>Conta:</strong> {{ itemCancelar.CONTA_NOME }}</p>
            <p class="mb-1"><strong>Período:</strong> {{ formatarDataBR(itemCancelar.DATA_INICIAL) }} a {{ formatarDataBR(itemCancelar.DATA_FINAL) }}</p>
            <p class="mb-0"><strong>Arquivo:</strong> {{ itemCancelar.NOME_ARQUIVO }}</p>
          </div>
        </div>
        <div class="mt-3">
          <label class="font-weight-bold">Motivo do Cancelamento:</label>
          <b-form-textarea v-model="motivoCancelamento" rows="3" placeholder="Informe o motivo..."></b-form-textarea>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { mapGetters } from 'vuex'
import { printHtmlReport, exportExcelXlsx } from '@/utils/RelatorioHTML'
import {
  STATUS_CONCILIACAO,
  getLabelStatusConciliacao,
  getVariantStatusConciliacao,
  getOptionsStatusConciliacao
} from '@/utils/conciliacaoStatus'

export default {
  components: { 
    SetFilter
  },
  mixins: [createCecTableToolsMixin({ 
    rowsProp: 'lista', 
    tblRef: 'tbl', 
    useExternalPaging: false, 
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'CONTA_NOME', type: 'string', label: 'Conta' },
      { key: 'BANCO_NOME', type: 'string', label: 'Banco' },
      { key: 'NOME_ARQUIVO', type: 'string', label: 'Arquivo' },
      { key: 'STATUS', type: 'string', label: 'Status' }
    ] 
  })],

  data() {
    return {
      isBusy: false,
      filtroAvancado: false,
      itemCancelar: null,
      motivoCancelamento: '',
      statusConciliacao: STATUS_CONCILIACAO,
      statusOptions: getOptionsStatusConciliacao(),
      contasBancarias: [],
      colunas: [
        { key: 'ID', label: 'ID', sortable: true, class: 'text-center', thStyle: { width: '80px' } },
        { key: 'CONTA_NOME', label: 'Conta', sortable: true, thStyle: { width: '200px' } },
        { key: 'BANCO_NOME', label: 'Banco', sortable: true, thStyle: { width: '180px' } },
        { key: 'DATA_INICIAL', label: 'Período De', sortable: true, class: 'text-center', thStyle: { width: '120px' } },
        { key: 'DATA_FINAL', label: 'Período Até', sortable: true, class: 'text-center', thStyle: { width: '120px' } },
        { key: 'NOME_ARQUIVO', label: 'Arquivo', sortable: true },
        { key: 'TRANSACOES', label: 'Transações', sortable: true, class: 'text-right', thStyle: { width: '110px' } },
        { key: 'TOTAL_CONCILIADO', label: 'Conciliado', sortable: true, class: 'text-right', thStyle: { width: '140px' } },
        { key: 'TOTAL_PENDENTE', label: 'Pendente', sortable: true, class: 'text-right', thStyle: { width: '140px' } },
        { key: 'STATUS', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: '140px' } },
        { key: 'actions', label: 'Ações', class: 'text-center', thStyle: { width: '120px' } }
      ]
    }
  }, 

  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    ...mapGetters('conciliacaoBancaria', [
      'LISTA',
      'FILTRO_CONTA_ID',
      'FILTRO_DATA_INICIAL',
      'FILTRO_DATA_FINAL',
      'FILTRO_STATUS',
      'FILTRO_NOME_ARQUIVO',
      'REGISTRO_SELECIONADO_ID',
      'RECARREGAR_LISTA'
    ]),

    lista: {
      get() { return this.LISTA },
      set(v) { this.$store.commit('conciliacaoBancaria/SET_LISTA', v) }
    },
    textoPesquisa: {
      get() { return this.$store.getters['conciliacaoBancaria/FILTRO_NOME_ARQUIVO'] },
      set(v) { this.$store.commit('conciliacaoBancaria/SET_FILTRO_NOME_ARQUIVO', v) }
    },
    filtroContaId: {
      get() { return this.FILTRO_CONTA_ID },
      set(v) { this.$store.commit('conciliacaoBancaria/SET_FILTRO_CONTA_ID', v) }
    },
    filtroDataInicial: {
      get() { return this.FILTRO_DATA_INICIAL },
      set(v) { this.$store.commit('conciliacaoBancaria/SET_FILTRO_DATA_INICIAL', v) }
    },
    filtroDataFinal: {
      get() { return this.FILTRO_DATA_FINAL },
      set(v) { this.$store.commit('conciliacaoBancaria/SET_FILTRO_DATA_FINAL', v) }
    },
    filtroStatus: {
      get() { return this.FILTRO_STATUS },
      set(v) { this.$store.commit('conciliacaoBancaria/SET_FILTRO_STATUS', v) }
    }
  },

  methods: {
    clicarLinha(item) { 
      this.$store.commit('conciliacaoBancaria/SET_REGISTRO_SELECIONADO_ID', item.ID) 
    },
    rowClassSelecionado(item, type) { 
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['conciliacaoBancaria/REGISTRO_SELECIONADO_ID']
      return item.ID === selId ? 'cec-row-selected' : ''
    },
    
    novo() {
      this.$router.push('/movimentos/conciliacao-bancaria/add')
    },
    
    edit(item) {
      this.$router.push(`/movimentos/conciliacao-bancaria/edit/${item.ID}`)
    },
    
    async pesquisar() {
      this.isBusy = true
      try {
        await this.$store.dispatch('conciliacaoBancaria/GET_LISTA')
      } catch (err) {
        console.error('Erro ao pesquisar conciliações', err)
        this.$bvToast.toast('Erro ao carregar conciliações', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isBusy = false
      }
    },

    limparFiltro() {
      this.$store.commit('conciliacaoBancaria/SET_LIMPAR')
      this.pesquisar()
    },

    abrirModalCancelar(item) {
      if (String(item.STATUS) === this.statusConciliacao.CANCELADA) {
        this.$bvToast.toast('Esta conciliação já está cancelada', {
          title: 'Aviso',
          variant: 'warning',
          solid: true
        })
        return
      }
      this.itemCancelar = item
      this.motivoCancelamento = ''
      this.$refs.modalCancelar.show()
    },

    async cancelar() {
      if (!this.motivoCancelamento || this.motivoCancelamento.trim() === '') {
        this.$bvToast.toast('Informe o motivo do cancelamento', {
          title: 'Aviso',
          variant: 'warning',
          solid: true
        })
        return
      }

      try {
        const body = {
          id: this.itemCancelar.ID,
          login: window.localStorage.getItem('login') || 'sistema',
          motivo: this.motivoCancelamento
        }
        
        await this.$http.post('/api/protected/conciliacao-bancaria/cancelar', body)
        
        this.$bvToast.toast('Conciliação cancelada com sucesso', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })
        
        this.pesquisar()
      } catch (err) {
        console.error('Erro ao cancelar conciliação', err)
        this.$bvToast.toast(err.response?.data || err.message || 'Erro ao cancelar conciliação', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    },

    async carregarContasBancarias() {
      try {
        const response = await this.$http.get('/api/protected/conciliacao-bancaria/contas-bancarias')
        this.contasBancarias = response.data
      } catch (err) {
        console.error('Erro ao carregar contas bancárias', err)
      }
    },

    getVariantStatus(status) {
      return getVariantStatusConciliacao(status)
    },

    getLabelStatus(status) {
      return getLabelStatusConciliacao(status)
    },

    formatarDataBR(data) {
      if (!data) return ''
      try {
        const d = new Date(data)
        return d.toLocaleDateString('pt-BR')
      } catch {
        return ''
      }
    },

    formatarMoeda(valor) {
      if (!valor && valor !== 0) return 'R$ 0,00'
      return new Intl.NumberFormat('pt-BR', { 
        style: 'currency', 
        currency: 'BRL' 
      }).format(valor)
    },

    exportarExcel() {
      exportExcelXlsx({
        rows: this.itensFiltrados,
        filename: 'Conciliação Bancária.xlsx',
        sheetName: 'ConciliacaoBancaria'
      })
    },
    exportarHtml() {
      printHtmlReport({
        rows: this.itensFiltrados,
        reportTitle: 'Conciliação Bancária',
        columns: this.colunas.filter(c => c.key !== 'actions')
      })
    }
  },

  async created() {
    await this.carregarContasBancarias()
    await this.pesquisar()
  },

  watch: {
    RECARREGAR_LISTA(val) {
      if (val) {
        this.pesquisar()
        this.$store.commit('conciliacaoBancaria/SET_RECARREGAR_LISTA', false)
      }
    }
  }
}
</script>

<style scoped>
.table-finance {
  font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// src/views/financeiro/conciliacao-bancaria/ConciliacaoBancariaListagem.vue